export default '/pricing/extension-paid-trial';
